var utils = {
  support: {
    touch: (function () {
      // eslint-disable-next-line
      return !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
    })()
  },
  env: {
    isWechat: /MicroMessenger/i.test(navigator.userAgent),
    isWeiyi: /WeiYi/i.test(navigator.userAgent),
    isIos: /(iPhone|iPad|iPod)/.test(navigator.userAgent),
    isAndroid: /Android/.test(navigator.userAgent)
  },
  now: function () {
    return new Date().getTime();
  },
  getRandom: function (min, max) {
    var range = max - min;
    var rand = Math.random();
    return min + Math.round(rand * range);
  },
  getUnique: function () {
    var unique = '';
    unique = this.now() + '_' + this.getRandom(0, 10000);
    return unique;
  },
  hasClass: function (obj, cls) {
    return obj.className.match(new RegExp(cls));
  },
  addClass: function (obj, cls) {
    if (!this.hasClass(obj, cls)) obj.className += ' ' + cls;
  },
  removeClass: function (obj, cls) {
    if (this.hasClass(obj, cls)) {
      var reg = new RegExp('(\\s|^)' + cls);
      obj.className = obj.className.replace(reg, '');
    }
  },
  noop: function () {},
  // 创建debug DOM
  createDebug: function () {
    var div = document.createElement('div');
    div.id = 'debug';
    div.style.position = 'fixed';
    div.style.top = '0px';
    div.style.left = '0px';
    div.style.right = '0px';
    div.style.zIndex = '9999';
    div.style.backgroundColor = 'rgba(0,0,0,0.8)';
    div.style.color = '#FFF';
    div.style.wordBreak = 'break-all';
    div.style.wordWrap = 'break-word';
    div.style.overflowY = 'scroll';
    div.style.fontSize = '10px';
    document.body.appendChild(div);
  },
  // 向debug DOM添加元素
  appendDebug: function (element, text, color) {
    var debug = document.getElementById('debug');
    var item = document.createElement(element);
    color = color || '#FFF';
    item.style.color = color;
    item.innerText = text;
    console.log(text);
    debug.appendChild(item);
  },
  // 是否是百分比数值
  isPercentage: function (value) {
    value = value + '';
    if (value.indexOf('%') !== -1) {
      return true;
    }
    return false;
  },
  // 百分比转小数
  percentageToNumber: function (value) {
    value = value + '';
    if (value.indexOf('%') !== -1) {
      value = parseFloat(value.replace('%', '')).toFixed(2);
      return (value / 100).toFixed(2);
    }
    return value;
  },
  // 获取viewport content中的参数
  getViewPortParam: function (name) {
    var viewport = document.querySelector('meta[name=viewport]');
    if (!viewport) {
      return null;
    }
    var content = viewport.getAttribute('content');
    if (!content) {
      return null;
    }
    // eslint-disable-next-line
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('(^|,)' + name + '=([^,]*)(,|$)', 'i');
    var results = regex.exec(content);
    return results === null ? null : decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  // 根据viewport设置放大倍数,默认为1
  getScale: function () {
    var initialScale = this.getViewPortParam('initial-scale') || 0;
    var maximumScale = this.getViewPortParam('maximum-scale') || 0;
    var minimumScale = this.getViewPortParam('minimum-scale') || 0;
    var scale = initialScale;
    if (maximumScale !== 0 && maximumScale <= initialScale) {
      scale = maximumScale;
    }
    if (minimumScale !== 0 && minimumScale >= initialScale) {
      scale = minimumScale;
    }
    return scale === 0 ? 1 : 1.0 / scale;
  }
}
export default utils;



// WEBPACK FOOTER //
// ./packages/utils/utils.js